import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { IncreaseBannerClickRequestModel } from 'src/app/shared/api-models/requests/banner/IncreaseBannerClickRequestModel';

/**
 * افزایش تعداد کلیک روی هر بنر
 */
@Injectable({
  providedIn: 'root'
})
export class IncreaseBannerClickService {
  constructor(private baseClient: BaseHttpClientService) {}

  /**
   * @param data 
   */
  call(data: IncreaseBannerClickRequestModel) {
      let res = this.baseClient.postWithAuth(
          `/api/v1/banner/increase_banner_click`, 
          data
      );

      return res;
  }
}
